import React, { FC, SVGProps } from 'react'

/* tslint:disable: max-line-length*/

export const DollarsIcon = (
  <svg
    version="1.1"
    id="budget_icon"
    x="0px"
    y="0px"
    width="20px"
    height="22px"
    viewBox="0 0 22 22"
  >
    <g>
      <path
        d="M11.001,0.002V0C4.926,0.002,0.002,4.926,0,11.001c0.002,6.075,4.926,10.999,11.001,11C17.076,22,22,17.076,22,11.001
		S17.076,0.002,11.001,0.002z M11.001,20c-4.972-0.01-8.992-4.028-9-9c0.008-4.971,4.029-8.992,9-9c4.971,0.008,8.989,4.029,8.999,9
		C19.991,15.972,15.972,19.991,11.001,20z"
      />
      <polygon points="7.294,14.71 7.295,14.708 7.294,14.708 	" />
      <path
        d="M12.292,6h-0.291V4.002h-2V6H9.708C8.212,6.003,7.002,7.212,7,8.708v0.586C7.002,10.79,8.212,12,9.708,12h2.585
		C12.684,12,13,12.316,13,12.708v0.586C13,13.686,12.684,14,12.292,14H9.708c-0.187,0-0.366-0.074-0.5-0.208l-0.5-0.5l-1.412,1.416
		l0.499,0.499C8.301,15.714,8.985,16,9.7,16c0.002,0,0.005,0,0.008,0H10v2.002h2.002V16h0.29C13.789,16,15,14.789,15,13.294v-0.586
		c0-1.495-1.212-2.707-2.708-2.707H9.708C9.316,10,9.002,9.685,9.002,9.294L9,8.708c0.002-0.391,0.316-0.706,0.708-0.706L12.292,8
		C12.684,8.002,13,8.317,13,8.708v0.294h2V8.708C15,7.212,13.789,6,12.292,6z"
      />
    </g>
  </svg>
)

export const ObjectIcon = (
  <svg width="20px" height="20px" viewBox="0 0 22 20">
    <path
      transform="translate(-1 0)"
      d="M3,8V4c0-1.104,0.896-2,2-2h14c1.104,0,2,0.896,2,2v4c1.104,0,2,0.896,2,2v8c0,1.104-0.896,2-2,2
		h-2v2h-2v-2H7v2H5v-2H3c-1.104,0-2-0.896-2-2v-8C1,8.896,1.896,8,3,8z M5,8c1.104,0,2,0.896,2,2v3h10v-3c0-1.104,0.896-2,2-2V4
		H5V8z M7,15v3h10v-3H7z M19,10v8h2v-8H19z M3,10v8h2v-8H3z"
    />
  </svg>
)

export const BrandIcon = (
  <svg version="1.1" id="brand_icon" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20">
    <path
      d="M10.394,19.998C9.66,20,8.92,19.714,8.361,19.158l0,0l0.001-0.001l-0.001-0.001l-8.067-8.059C0.107,10.911,0,10.653,0,10.39
	l0,0V1c0-0.263,0.107-0.521,0.294-0.708l0,0C0.479,0.107,0.737,0,1,0l0,0h9.39c0.264,0,0.521,0.105,0.706,0.292l0,0l8.068,8.071
	C19.72,8.92,20,9.66,19.999,10.39l0,0c0.002,0.712-0.267,1.431-0.792,1.984l0,0c-0.015,0.017-0.029,0.032-0.044,0.048l0,0
	l-6.733,6.736c-0.56,0.556-1.297,0.84-2.027,0.84l0,0C10.399,19.998,10.397,19.998,10.394,19.998L10.394,19.998z M9.775,17.742
	c0.17,0.173,0.393,0.257,0.619,0.257l0,0c0.227,0,0.448-0.084,0.621-0.257l0,0l6.727-6.73l0,0l0,0C17.916,10.835,18,10.614,18,10.39
	l0,0c-0.002-0.229-0.084-0.444-0.253-0.618l0,0L9.974,2H2v7.976l7.763,7.757L9.775,17.742L9.775,17.742z"
    />
  </svg>
)

export const StyleIcon = (
  <svg version="1.1" id="style_icon" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20">
    <path
      d="M0.554,6.396l8.999,4.499C9.692,10.965,9.846,11,10,11c0.153,0,0.307-0.035,0.448-0.105l8.999-4.499
		c0.339-0.171,0.552-0.515,0.552-0.896c0-0.378-0.213-0.725-0.552-0.893l-8.999-4.501c-0.282-0.14-0.613-0.14-0.896,0L0.554,4.607
		C0.214,4.775,0,5.122,0,5.5C0,5.881,0.214,6.225,0.554,6.396z M10,2.118L16.764,5.5L9.999,8.882L3.235,5.5L10,2.118z"
    />
    <path
      d="M18.553,13.607l-8.554,4.275l-8.552-4.277c-0.494-0.247-1.095-0.047-1.34,0.449c-0.247,0.493-0.047,1.093,0.447,1.34
		l8.999,4.499c0.14,0.07,0.293,0.105,0.447,0.105c0.153,0,0.307-0.035,0.448-0.105l8.999-4.499c0.492-0.247,0.693-0.847,0.446-1.34
		C19.646,13.561,19.047,13.36,18.553,13.607z"
    />
    <path
      d="M18.553,9.106l-8.554,4.276L1.447,9.106c-0.494-0.247-1.095-0.047-1.34,0.448c-0.247,0.492-0.047,1.093,0.447,1.34
		l8.999,4.5c0.14,0.069,0.293,0.104,0.447,0.104c0.153,0,0.307-0.035,0.448-0.104l8.999-4.5c0.492-0.247,0.693-0.848,0.446-1.34
		C19.646,9.061,19.047,8.861,18.553,9.106z"
    />
  </svg>
)

export const MaterialIcon = (
  <svg
    version="1.1"
    id="material_icon"
    x="0px"
    y="0px"
    width="20px"
    height="20px"
    viewBox="0 0 20 18"
  >
    <path
      transform="translate(-2 -2)"
      d="M5,5v14h14V5H5z M5,3h14c1.104,0,2,0.896,2,2v14c0,1.104-0.896,2-2,2H5c-1.104,0-2-0.896-2-2V5
		C3,3.896,3.896,3,5,3z M4.491,11.065L3.077,9.651l6.065-6.065L10.556,5L4.491,11.065z M5,20.557l-1.414-1.414L19.143,3.586
		L20.557,5L5,20.557z M4.491,16.065l-1.414-1.414L14.143,3.586L15.557,5L4.491,16.065z M10,20.557l-1.414-1.414L19.49,8.237
		l1.415,1.415L10,20.557z M15,20.557l-1.414-1.414l5.904-5.906l1.415,1.415L15,20.557z"
    />
  </svg>
)

export const RoomIcon = (
  <svg version="1.1" id="room_icon" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 18 18">
    <path
      d="M16,0H2C0.895,0,0,0.895,0,2v13.999c0,1.105,0.895,2,2,2h2V18h10v-0.001h2c1.105,0,2-0.895,2-2V2C18,0.895,17.105,0,16,0z
	 M12,15.999H6.072c0.442-3.065,2.864-5.484,5.927-5.928V15.999z M16,15.999h-2v-8h-1c-4.631,0.002-8.443,3.5-8.941,8H2V2h14V15.999z
	"
    />
  </svg>
)

export const ColorIcon = (
  <svg version="1.1" id="color_icon" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20">
    <path
      d="M19.086,14.813L9.816,5.542l1.864-1.864l-1.415-1.415L8.401,4.126L5.129,0.854C4.53,0.28,3.771-0.002,3.021,0
	C2.231-0.002,1.43,0.313,0.839,0.932C0.282,1.511,0,2.27,0,3.02c0,0.751,0.284,1.509,0.839,2.091L4.128,8.4l-1.864,1.863
	l1.415,1.415l1.864-1.864l9.272,9.272c0.587,0.587,1.367,0.885,2.135,0.883c0.003,0,0.005,0,0.008,0c0.768,0,1.54-0.298,2.125-0.879
	c0.572-0.57,0.889-1.34,0.889-2.141C19.971,16.147,19.655,15.379,19.086,14.813z M2.27,3.713C2.093,3.526,2.002,3.277,2,3.02
	c0.002-0.257,0.093-0.504,0.284-0.704C2.488,2.102,2.75,2,3.021,1.999C3.279,2,3.528,2.091,3.729,2.285l3.257,3.257L5.542,6.985
	L2.27,3.713z M17.672,17.672c-0.202,0.199-0.459,0.296-0.723,0.299c-0.266-0.003-0.519-0.1-0.721-0.301L6.958,8.4l1.444-1.444
	l9.271,9.271c0.191,0.191,0.298,0.451,0.301,0.723C17.973,17.221,17.864,17.481,17.672,17.672z"
    />
  </svg>
)
export const OriginIcon = (
  <svg
    version="1.1"
    id="madein_icon"
    x="0px"
    y="0px"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
  >
    <path
      d="M18,0H0v19h2v-5.002L18,14c1.105-0.002,1.999-0.896,1.999-2.001V2C19.999,0.896,19.105,0,18,0z M12,2V12H8V2H12z M2,2h4V12
	H2V2z M18,12H14V2H18V12z"
    />
  </svg>
)

export const Directory: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="20px" height="24px" viewBox="0 0 24 24" version="1.1" {...props}>
    <g id="Addsome---Studio" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Packshot---Projet---Rendus-(1)-(1)"
        transform="translate(-168.000000, -105.000000)"
        fill="#000000"
      >
        <g id="directory_close-[#1655]" transform="translate(168.000000, 105.000000)">
          <path d="M14.676,11.9796 C14.6688,11.9724 14.6568,11.9688 14.6496,11.9616 C14.6424,11.9544 14.6412,11.9448 14.634,11.9376 L14.676,11.9796 Z M21.6,20.4 C21.6,21.0624 21.0684,21.6 20.406,21.6 L3.606,21.6 C2.9436,21.6 2.4,21.0624 2.4,20.4 L2.4,3.6 C2.4,2.9376 2.9436,2.4 3.606,2.4 L7.632,2.4 C8.0904,2.4 8.508,2.6604 8.7096,3.0732 L10.0728,5.856 C10.4748,6.678 11.3112,7.2 12.228,7.2 L20.406,7.2 C21.0684,7.2 21.6,7.7376 21.6,8.4 L21.6,20.4 Z M21.606,4.8 L13.4892,4.8 C12.5796,4.8 11.7492,4.2864 11.3424,3.474 L10.2696,1.3272 C9.8628,0.5136 9.0312,0 8.1228,0 L2.406,0 C1.08,0 0,1.0752 0,2.4 L0,21.6 C0,22.926 1.08,24 2.406,24 L21.606,24 C22.9308,24 24,22.926 24,21.6 L24,7.2 C24,5.8752 22.9308,4.8 21.606,4.8 L21.606,4.8 Z"></path>
          <path
            d="M10.7757038,18.52576 L10.7805038,18.52216 C11.2641038,18.07216 11.2905038,17.31496 10.8393038,16.83256 L9.69090384,15.60736 C9.33210384,15.22336 9.60450384,14.59696 10.1289038,14.59696 L17.5833038,14.59696 C18.2469038,14.59696 18.7833038,14.05936 18.7833038,13.39696 C18.7833038,12.73456 18.2469038,12.19696 17.5833038,12.19696 L10.1469038,12.19696 C9.61890384,12.19696 9.34890384,11.56456 9.71370384,11.18296 L10.8273038,10.01416 C11.2857038,9.53536003 11.2641038,8.77456003 10.7805038,8.32216003 C10.3017038,7.87336003 9.54930384,7.89616003 9.09810384,8.37376003 L5.87130384,11.79136 C4.99530384,12.72016 4.99890384,14.17216 5.87970384,15.09496 L9.10290384,18.47416 C9.55290384,18.94576 10.2981038,18.96856 10.7757038,18.52576"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export const RectPlusIcon = () => (
  <svg width="20px" height="18px" viewBox="0 0 18 18" version="1.1">
    <g id="Addsome---Studio" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Ambiance---Configurateur-3D---Décor-(1)-(1)"
        transform="translate(-1254.000000, -775.000000)"
        fill="currentColor"
      >
        <path
          d="M1262.64637,783.538497 L1260.09637,783.538497 L1260.09637,781.838497 L1262.64637,781.838497 L1262.64637,779.288497 L1264.34637,779.288497 L1264.34637,781.838497 L1266.89637,781.838497 L1266.89637,783.538497 L1264.34637,783.538497 L1264.34637,786.088497 L1262.64637,786.088497 L1262.64637,783.538497 Z M1256.69637,788.638497 L1270.29637,788.638497 L1270.29637,776.738497 L1256.69637,776.738497 L1256.69637,788.638497 Z M1254.99637,792.038497 L1269.44637,792.038497 L1271.99637,792.038497 L1271.99637,775.038497 L1254.99637,775.038497 L1254.99637,792.038497 Z"
          id="image_plus-[#988]"
        ></path>
      </g>
    </g>
  </svg>
)

export const TrashIcon = () => (
  <svg width="20px" height="19px" viewBox="0 0 16 19">
    <g id="Addsome---Studio" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Ambiance---Configurateur-3D---Décor-(1)-(1)"
        transform="translate(-1224.000000, -774.000000)"
      >
        <g id="Trash-2-Copy" transform="translate(1219.992734, 771.538497)">
          <rect id="Rectangle" fillRule="nonzero" x="0" y="0" width="24" height="24"></rect>
          <polyline
            id="Path"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="square"
            points="5 7.2 6.55555556 7.2 19 7.2"
          ></polyline>
          <path
            d="M17.4444444,7.2 L17.4444444,18.4 L17.4444444,18.4 C17.4444444,19.283656 16.7479981,20 15.8888889,20 L8.11111111,20 L8.11111104,20 C7.25200104,20 6.55555549,19.2836552 6.55555549,18.4 C6.55555549,18.4 6.55555549,18.4 6.55555549,18.4 L6.55555549,7.2 M8.88888882,7.20000024 L8.88888882,5.6 L8.88888882,5.60000024 C8.88888869,4.71634424 9.58533438,4.00000024 10.4444444,4.00000024 L13.5555555,4.00000024 L13.5555554,4.00000024 C14.4146654,4.0000002 15.111111,4.71634424 15.111111,5.60000024 L15.111111,7.20000024"
            id="Shape"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="square"
          ></path>
          <path
            d="M10.4444444,11.2 L10.4444444,16"
            id="Path"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="square"
          ></path>
          <path
            d="M13.5555556,11.2 L13.5555556,16"
            id="Path"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="square"
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export const Have3DIcon = (
  <svg width="20px" height="20px" viewBox="0 0 24 24">
    <g id="BO" fill="none" fillRule="evenodd">
      <g id="Marque---Produit---Fichiers" transform="translate(-134 -872)" fill="none">
        <g transform="translate(110 848)" fill="none">
          <g transform="translate(8 8)" fill="none">
            <g id="Données-3D" transform="translate(16 16)" fill="none">
              <rect id="Rectangle" width="24" height="24" />
              <g
                transform="translate(2 1)"
                stroke="#0F0F0F"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <path
                  id="Path"
                  d="m10.89 0.2089 8 4 2e-7 9e-8c0.67966 0.33773 1.1096 1.0311 1.11 1.79v9.53-8.48e-5c-3.706e-4 0.75894-0.43028 1.4523-1.1099 1.79l-8 4h1e-7c-0.56337 0.28191-1.2266 0.28191-1.79 1e-7l-8-4-3e-7 -2e-7c-0.67901-0.34213-1.1053-1.0397-1.1-1.8v-9.52l-4.3244e-8 8.489e-5c3.7051e-4 -0.75894 0.43028-1.4523 1.1099-1.79l8-4 1.5e-7 -7.7e-8c0.56063-0.27859 1.2194-0.27859 1.78 1.54e-7l-1e-7 -4.0223e-5z"
                />
                <polyline points="0.31997 4.9189 10 9.7589 19.68 4.9189" />
                <path d="m10 21.519v-11.76" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const SizeIcon = (
  <svg
    id="Component_1_1"
    data-name="Component 1 – 1"
    xmlns="http://www.w3.org/2000/svg"
    width="20px"
    height="20px"
    viewBox="0 0 512 510.545"
  >
    <defs>
      <rect id="Rectangle_1" data-name="Rectangle 1" width="20px" height="20px" fill="none" />
    </defs>
    <g id="Group_3" data-name="Group 3">
      <path
        id="Path_10"
        data-name="Path 10"
        d="M28.485,20.38c0-3.061.189-6.227-.461-9.162C26.43,4.069,21.566.064,14.354,0,7.561-.061,2.592,3.524.831,10.3a39.242,39.242,0,0,0-.8,9.938q-.063,115.038,0,230.1c0,3.334-.084,6.793.755,9.938,1.908,7.044,6.9,10.671,14.236,10.357v.042c7.023-.294,11.363-4.34,12.957-11.007.692-2.935.5-6.1.5-9.162q.031-57.33,0-114.64Z"
        transform="translate(0.003 0.001)"
      />
      <path
        id="Path_11"
        data-name="Path 11"
        d="M115.39,162.63c-.042.839-.042,1.887-.042,3.1.063-1.908.1-3.1.1-3.1Z"
        transform="translate(126.486 178.333)"
      />
      <path
        id="Path_12"
        data-name="Path 12"
        d="M204.034,148.026q85.634.031,171.268.021v-.021q-85.634,0-171.268,0m156.739,53.735c-.063-3.145-.1-6.269-.126-9.414v4.109c0,1.8,0,3.606.042,5.43.1,8.344,3.187,14.068,8.491,16.332-5.116-2.432-8.219-8.239-8.407-16.458m-56.586-14.236V176.539H303.7s-.042,5.661-.042,8.323c-.042,15.619.084,31.239-.084,46.858-.084,9.2-5.158,15.494-12.537,16.269a13.614,13.614,0,0,0,12.873-13.607c.419-15.619.231-31.239.273-46.858m-85.98-8.889v17.946c0,1.8,0,3.606-.042,5.409-.063,4.78-1.09,8.659-2.935,11.552a22.43,22.43,0,0,0,3.166-11.783c0-1.384.063-2.788.063-4.172v-.147c.084-6.1.084-12.2.168-18.282v-2.621h-.419Zm-.063,0h-.063s.042,1.2.1,3.1c0-1.216,0-2.264-.042-3.1M210.03,218.2a13.72,13.72,0,0,1-2.663.9,11.386,11.386,0,0,0,2.663-.9m-6.311,1.279h.21a3.387,3.387,0,0,1-.65-.042,3.128,3.128,0,0,0,.44.042m-9.057-3.648a14.183,14.183,0,0,1-1.845-2.285,12.4,12.4,0,0,0,1.845,2.285m-61.723-39.289h-.461v20.986c0,9.707,0,20.735-.042,28.157a52.878,52.878,0,0,1-.8,10.776c-1.51,7.17-7.464,11.825-14.047,11.573a5.752,5.752,0,0,0,1.048.063c8.2-.042,14.11-6.541,14.236-16.437.084-7.3.1-17.653.1-27.444,0-13.565-.042-25.578-.042-25.578Zm-85.539,0V190.46c.042-3.774.042-7.548.084-11.3.021-.5,0-2.621,0-2.621Z"
        transform="translate(51.977 162.319)"
      />
      <path
        id="Path_13"
        data-name="Path 13"
        d="M492.02,148.047H427.278q-85.634,0-171.268-.021-85.665.031-171.31.021H19.98C4.717,148.047,0,152.785,0,168.09V327.91c0,15.745,4.57,20.316,20.546,20.316H491.454c15.976,0,20.546-4.57,20.546-20.316V168.09c0-15.3-4.717-20.043-19.98-20.043m-221.9,30.589c.042.839.042,1.887.042,3.1-.063-1.908-.1-3.1-.1-3.1Zm-28.241,0h.063s-.042,1.2-.1,3.1c0-1.216,0-2.264.042-3.1M483.067,319.1H28.932V176.539H70.7v3.271c-.021,5.095-.042,10.022-.021,14.844v1.929c.021,1.8.021,3.606.042,5.409.168,10.881,5.3,17.255,13.837,17.485a13.634,13.634,0,0,0,5.241-.839,7.167,7.167,0,0,0,.713-.273,1.062,1.062,0,0,0,.314-.147c5.116-2.411,8.239-8.239,8.428-16.458.084-3.753.126-7.527.126-11.3V176.539h56.942s.042,5.661.042,8.323c.042,15.619-.084,31.239.084,46.858.084,9.2,5.158,15.494,12.537,16.269a2.063,2.063,0,0,0,.356.042.851.851,0,0,0,.231,0c6.583.252,12.537-4.4,14.047-11.573a52.879,52.879,0,0,0,.8-10.776c.042-7.422.042-18.45.042-28.157V176.539h57.362v20.043c0,1.8,0,3.606.042,5.409.084,4.78,1.09,8.659,2.935,11.552a14.183,14.183,0,0,0,1.845,2.285q.535.5,1.069.943a10.3,10.3,0,0,0,1.153.8,9.818,9.818,0,0,0,1.132.629,11.238,11.238,0,0,0,1.258.5,10.738,10.738,0,0,0,1.4.4c.482.1.964.189,1.468.252a6.864,6.864,0,0,0,1.132.084,3.387,3.387,0,0,0,.65.042h.189a3.173,3.173,0,0,0,.629-.042,6.538,6.538,0,0,0,1.132-.084c.5-.063,1.006-.147,1.489-.252a13.72,13.72,0,0,0,2.663-.9,9.816,9.816,0,0,0,1.132-.629,10.3,10.3,0,0,0,1.153-.8q.535-.44,1.069-.943a14.184,14.184,0,0,0,1.845-2.285c1.845-2.893,2.872-6.772,2.935-11.552.042-1.8.042-3.606.042-5.409V176.539h57.362v20.986c0,9.707,0,20.735.042,28.157a52.876,52.876,0,0,0,.8,10.776c1.51,7.17,7.464,11.825,14.047,11.573a1.809,1.809,0,0,0,.587-.042c7.38-.776,12.454-7.065,12.537-16.269.168-15.619.042-31.239.084-46.858,0-2.663.042-8.323.042-8.323h56.942v15.808c.021,3.145.063,6.269.126,9.414.189,8.219,3.292,14.026,8.407,16.458a10.018,10.018,0,0,0,1.006.4,13.851,13.851,0,0,0,5.283.86c8.533-.231,13.669-6.6,13.837-17.485.021-1.8.021-3.606.042-5.409v-1.929c.021-4.822,0-9.749-.021-14.844v-3.271h41.763Z"
        transform="translate(0 162.319)"
      />
      <path
        id="Path_14"
        data-name="Path 14"
        d="M368.238,176.539s-.021,2.118,0,2.621q.063,6.573.084,13.187V176.539Zm-84.156,59.92a52.878,52.878,0,0,1-.8-10.776c-.042-7.422-.042-18.45-.042-28.157V176.539h-.461v2.1s-.042,12.013-.042,25.578c0,9.791.021,20.148.1,27.444.126,9.9,6.038,16.4,14.236,16.437a5.752,5.752,0,0,0,1.048-.063c-6.583.252-12.537-4.4-14.047-11.573m-61.178-22.915a14.183,14.183,0,0,1-1.845,2.285,12.4,12.4,0,0,0,1.845-2.285M212,219.477a1.358,1.358,0,0,0,.419-.042,3.174,3.174,0,0,1-.629.042ZM40.4,148.026v.021q85.665,0,171.31-.021-85.634.031-171.289,0Zm157.116,48.556V176.539H197.1v2.621c.084,6.08.084,12.181.168,18.282v.147c0,1.384.063,2.788.063,4.172a22.43,22.43,0,0,0,3.166,11.783c-1.845-2.893-2.851-6.772-2.935-11.552-.042-1.8-.042-3.606-.042-5.409m.063-17.946c-.042.839-.042,1.887-.042,3.1.063-1.908.1-3.1.1-3.1Zm-85.435,53.085c-.168-15.619-.042-31.239-.084-46.858,0-2.663-.042-8.323-.042-8.323h-.482v10.986c.042,15.619-.147,31.239.273,46.858a13.614,13.614,0,0,0,12.873,13.607c-7.38-.776-12.454-7.065-12.537-16.269m-65.622-13.5c5.3-2.243,8.407-7.967,8.512-16.332.042-1.824.042-3.627.042-5.43v-6c0,3.774-.042,7.548-.126,11.3-.189,8.219-3.313,14.047-8.428,16.458"
        transform="translate(44.301 162.319)"
      />
      <path
        id="Path_15"
        data-name="Path 15"
        d="M419.88,103.676c-20.169-25.934-40.464-51.785-60.632-77.74-4.529-5.807-9.644-10.525-17.59-7.631-7.422,2.726-8.847,9.33-8.868,16.311-.042,19.33,0,38.64-.042,57.97V102h-.839q-106.516-.063-213.01,0V90.929c0-19.037.042-38.094-.063-57.131-.021-7.128-2.264-13.313-9.77-15.7-7.4-2.369-11.992,2.1-16.123,7.4Q62.407,64.712,31.787,103.865a20.269,20.269,0,0,0,0,24.907c20.169,25.934,40.464,51.785,60.632,77.74,4.529,5.807,9.644,10.525,17.59,7.631,7.422-2.726,8.847-9.33,8.868-16.311.042-19.33,0-38.64.042-57.97v-9.414q52.267.031,104.513,0H332.769v11.07c0,19.037-.042,38.094.063,57.131.021,7.128,2.264,13.313,9.77,15.7,7.4,2.369,11.992-2.1,16.123-7.4q30.536-39.216,61.156-78.369a20.269,20.269,0,0,0,0-24.907m-326.1,57.53c-11.992-15.556-22.831-29.478-33.419-43.587-.776-1.048-.461-3.879.419-5.053,10.357-13.711,20.924-27.255,33-42.875Zm297.1-41.323c-10.357,13.711-20.924,27.255-33,42.875V71.242C369.878,86.8,380.717,100.72,391.3,114.83c.776,1.048.461,3.879-.419,5.053"
        transform="translate(30.166 19.111)"
      />
      <path
        id="Path_16"
        data-name="Path 16"
        d="M230.634,250.287c0,3.061-.189,6.227.461,9.162,1.593,7.149,6.457,11.154,13.67,11.217,6.793.063,11.762-3.522,13.523-10.294a39.243,39.243,0,0,0,.8-9.938q.063-115.038,0-230.1c0-3.334.084-6.793-.755-9.938-1.908-7.044-6.9-10.671-14.236-10.357V0c-7.023.294-11.363,4.34-12.957,11.007-.692,2.935-.5,6.1-.5,9.162q-.031,57.33,0,114.64Z"
        transform="translate(252.876)"
      />
    </g>
  </svg>
);

export const ThumbnailUnchecked = ({
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="15px" height="15px" viewBox="0 0 512 512">
    <path fill="#fff" d="M496.5,0H310.8c-8.5,0-15.5,7-15.5,15.5v185.7c0,8.5,7,15.5,15.5,15.5h185.7c8.5,0,15.5-7,15.5-15.5V15.5  C512,7,505,0,496.5,0z M475.2,169.6c0,5.6-4.6,10.2-10.2,10.2H342.4c-5.6,0-10.2-4.6-10.2-10.2V47c0-5.6,4.6-10.2,10.2-10.2H465  c5.6,0,10.2,4.6,10.2,10.2V169.6z" />
    <path fill="#fff" d="m496.5 295.3h-185.7c-8.5 0-15.5 7-15.5 15.5v185.7c0 8.5 7 15.5 15.5 15.5h185.7c8.5 0 15.5-7 15.5-15.5v-185.7c0-8.5-7-15.5-15.5-15.5zm-21.3 169.7c0 5.6-4.6 10.2-10.2 10.2h-122.6c-5.6 0-10.2-4.6-10.2-10.2v-122.6c0-5.6 4.6-10.2 10.2-10.2h122.6c5.6 0 10.2 4.6 10.2 10.2v122.6z" />
    <path fill="#fff" d="m201.2 295.3h-185.7c-8.5 0-15.5 7-15.5 15.5v185.7c0 8.5 7 15.5 15.5 15.5h185.7c8.5 0 15.5-6.9 15.5-15.5v-185.7c0-8.5-7-15.5-15.5-15.5zm-21.3 169.7c0 5.6-4.6 10.2-10.2 10.2h-122.7c-5.6 0-10.2-4.6-10.2-10.2v-122.6c0-5.6 4.6-10.2 10.2-10.2h122.6c5.6 0 10.2 4.6 10.2 10.2v122.6z" />
    <path fill="#fff" d="M201.2,0H15.5C7,0,0,7,0,15.5v185.7c0,8.5,7,15.5,15.5,15.5h185.7c8.5,0,15.5-7,15.5-15.5V15.5  C216.7,7,209.7,0,201.2,0z M179.9,169.6c0,5.6-4.6,10.2-10.2,10.2H47c-5.6,0-10.2-4.6-10.2-10.2V47c0-5.6,4.6-10.2,10.2-10.2h122.6  c5.6,0,10.2,4.6,10.2,10.2V169.6z" />
  </svg>
)

export const ThumbnailChecked = ({  }: React.SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="15px"
    height="15px"
  >
    <g>
      <rect fill="#fff" x="3.5" y="3.5" width="209.67" height="209.67" rx="12" ry="12" />
      <path
        fill="#fff"
        d="M201.17,216.67H15.5c-8.55,0-15.5-6.95-15.5-15.5V15.5C0,6.95,6.95,0,15.5,0H201.17c8.55,0,15.5,6.95,15.5,15.5V201.17c0,8.55-6.95,15.5-15.5,15.5ZM15.5,7c-4.69,0-8.5,3.81-8.5,8.5V201.17c0,4.69,3.81,8.5,8.5,8.5H201.17c4.69,0,8.5-3.81,8.5-8.5V15.5c0-4.69-3.81-8.5-8.5-8.5H15.5Z"
      />
    </g>
    <g>
      <rect fill="#fff" x="3.5" y="298.83" width="209.67" height="209.67" rx="12" ry="12" />
      <path
        fill="#fff"
        d="M201.17,512H15.5c-8.55,0-15.5-6.95-15.5-15.5v-185.67c0-8.55,6.95-15.5,15.5-15.5H201.17c8.55,0,15.5,6.95,15.5,15.5v185.67c0,8.55-6.95,15.5-15.5,15.5ZM15.5,302.33c-4.69,0-8.5,3.81-8.5,8.5v185.67c0,4.69,3.81,8.5,8.5,8.5H201.17c4.69,0,8.5-3.81,8.5-8.5v-185.67c0-4.69-3.81-8.5-8.5-8.5H15.5Z"
      />
    </g>
    <g>
      <rect fill="#fff" x="298.83" y="298.83" width="209.67" height="209.67" rx="12" ry="12" />
      <path
        fill="#fff"
        d="M496.5,512h-185.67c-8.55,0-15.5-6.95-15.5-15.5v-185.67c0-8.55,6.95-15.5,15.5-15.5h185.67c8.55,0,15.5,6.95,15.5,15.5v185.67c0,8.55-6.95,15.5-15.5,15.5Zm-185.67-209.67c-4.69,0-8.5,3.81-8.5,8.5v185.67c0,4.69,3.81,8.5,8.5,8.5h185.67c4.69,0,8.5-3.81,8.5-8.5v-185.67c0-4.69-3.81-8.5-8.5-8.5h-185.67Z"
      />
    </g>
    <g>
      <rect fill="#fff" x="298.83" y="3.5" width="209.67" height="209.67" rx="12" ry="12" />
      <path
        fill="#fff"
        d="M496.5,216.67h-185.67c-8.55,0-15.5-6.95-15.5-15.5V15.5c0-8.55,6.95-15.5,15.5-15.5h185.67c8.55,0,15.5,6.95,15.5,15.5V201.17c0,8.55-6.95,15.5-15.5,15.5ZM310.83,7c-4.69,0-8.5,3.81-8.5,8.5V201.17c0,4.69,3.81,8.5,8.5,8.5h185.67c4.69,0,8.5-3.81,8.5-8.5V15.5c0-4.69-3.81-8.5-8.5-8.5h-185.67Z"
      />
    </g>
  </svg>
)
